import React from "react";
import Modal from "react-modal";

export default ({
  cancelSellOrder,
  closeCancelSellOrderModal,
  sellOrderToCancel,
  open,
}) => (
  <Modal
    className="Modal__Bootstrap modal-dialog"
    closeTimeoutMS={150}
    isOpen={open}
    contentLabel="Support"
  >
    <div className="modal-content modal-content-padding">
      <div className="modal-header mar-t-5">
        <div className="acct-modal-close-btn">
          <i
            className="fa fa-times"
            aria-hidden="true"
            onClick={closeCancelSellOrderModal}
          ></i>
        </div>
        <div className="acct-modal-heading">Cancel Order</div>
        <div className="acct-modal-hr"></div>
      </div>
      <div
        className="modal-body modal-body-padding"
        style={{ fontSize: "14px" }}
      >
        <div className="acct-modal-text">
          Are you sure you want to cancel your order?
        </div>
        <div className="modal-input-mar-b-20">
          <div className="modal-input-flex-2-pad-r-10">
            <button
              type="submit"
              className="acct-pg-btn acct-pg-btn-block"
              onClick={cancelSellOrder.bind(null, sellOrderToCancel)}
            >
              Cancel Order
            </button>
          </div>
          <div className="modal-input-pad-l-10">
            <button
              type="submit"
              className="acct-pg-btn-inverse acct-pg-btn-block"
              onClick={closeCancelSellOrderModal}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </Modal>
);
